export default __webpack_public_path__ + "static/media/Stars.39872749.png";